// ページトップへスクロールするボタンコンポーネント

export function initScrollToTop() {
  // ボタンのHTMLを追加
  const scrollButton = document.createElement('button');
  scrollButton.id = 'scroll-to-top';
  scrollButton.innerHTML = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 19V5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 12L12 5L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;
  scrollButton.setAttribute('aria-label', 'ページトップへ戻る');
  document.body.appendChild(scrollButton);
  
  // スタイルを追加
  const style = document.createElement('style');
  style.textContent = `
    #scroll-to-top {
      position: fixed;
      bottom: 30px;
      right: 30px;
      width: 50px;
      height: 50px;
      background: #E60012;
      border: none;
      border-radius: 50%;
      color: white;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 9999;
      box-shadow: 0 4px 12px rgba(230, 0, 18, 0.3);
    }
    
    #scroll-to-top:hover {
      background: #cc0010;
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(230, 0, 18, 0.4);
    }
    
    #scroll-to-top.visible {
      opacity: 1;
      visibility: visible;
    }
    
    #scroll-to-top svg {
      width: 24px;
      height: 24px;
    }
    
    /* モバイル対応 */
    @media (max-width: 768px) {
      #scroll-to-top {
        bottom: 20px;
        right: 20px;
        width: 45px;
        height: 45px;
      }
      
      #scroll-to-top svg {
        width: 20px;
        height: 20px;
      }
    }
    
    /* アニメーション */
    @keyframes bounce {
      0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
      }
      40% {
        transform: translateY(-10px);
      }
      60% {
        transform: translateY(-5px);
      }
    }
    
    #scroll-to-top.bounce {
      animation: bounce 1s;
    }
  `;
  document.head.appendChild(style);
  
  // スクロール位置を監視してボタンの表示/非表示を切り替え
  let isScrolling = false;
  
  const handleScroll = () => {
    if (!isScrolling) {
      window.requestAnimationFrame(() => {
        if (window.pageYOffset > 300) {
          scrollButton.classList.add('visible');
        } else {
          scrollButton.classList.remove('visible');
        }
        isScrolling = false;
      });
      isScrolling = true;
    }
  };
  
  // スクロールイベントをデバウンス処理
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(handleScroll, 10);
  });
  
  // 初回チェック
  handleScroll();
  
  // クリックイベント
  scrollButton.addEventListener('click', () => {
    // ボタンにバウンスアニメーションを追加
    scrollButton.classList.add('bounce');
    
    // スムーズスクロール
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    // アニメーション終了後にクラスを削除
    setTimeout(() => {
      scrollButton.classList.remove('bounce');
    }, 1000);
  });
  
  // キーボードアクセシビリティ対応
  scrollButton.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollButton.click();
    }
  });
}

// コンポーネントを返す関数（他のコンポーネントと統一性を保つため）
export function ScrollToTop() {
  // DOMContentLoadedまたは即座に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToTop);
  } else {
    initScrollToTop();
  }
  
  // 空の文字列を返す（HTMLには何も追加しない）
  return '';
}